module.exports = __webpack_public_path__ + "img/close.a1b12147.svg";